// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__T8yde","inputWrap":"styles_inputWrap__2R32K","input":"styles_input__DWk7F"};